<script setup lang="ts">
import type { SightlineObjectiveCell } from "@/backend/natsstubs/sightline/models";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

defineProps<{ cell: SightlineObjectiveCell }>();
</script>

<template>
  <SightlineTruncatedText
    :text="cell.label"
    :icon="cell.level === 'art' ? 'board/objectives-art' : 'board/objectives-team'"
  />
</template>
